import * as React from 'react';

import {Card} from "@mui/material";
import {styled} from "@mui/material/styles";

const StyledCard = styled(Card)(({ theme }) => ({
    '& .MuiCardHeader-root': {
        borderBottom: 'none',
        '& .MuiCardHeader-title': {
            fontSize: '1.3rem',
            color: theme.palette.secondary.dark,
            fontWeight: 600,
            [theme.breakpoints.down('sm')]: {
                display: 'none', // Hide title for small screens
            },
            [theme.breakpoints.up('sm')]: {
                display: 'block', // Show title for medium screens and above
            },
        },
        '& .MuiCardHeader-avatar': {
            marginRight: '1rem',
        },
        '& .MuiCardHeader-subheader': {
            fontSize: '0.9rem',
            color: theme.palette.text.secondary,
            fontWeight: 400,
        },
        '& .MuiCardHeader-action': {
            margin:0,
            '& .MuiButton-root': {
            }
        }
    },
    '& .MuiCardContent-root': {
        margin: theme.spacing(0, 0, 0, 2) + '!important',
        padding: theme.spacing(0, 0, 0, 0) + '!important',
    }
}));


export const ToolbarCard = ({children, props, styles}) => {

    return (
        <StyledCard {...props} {...styles}>
            {children}
        </StyledCard>
    )
}